import type { IntlService } from 'ember-intl';
import type { TOnHandSourcing } from '../types/planning-settings';

export const OnHandSourcings: Record<TOnHandSourcing, string> = {
  SIMULATED_ON_HAND: 'onHandSourcingOptions.SIMULATED_ON_HAND',
  REAL_BALANCE: 'onHandSourcingOptions.REAL_BALANCE',
  SIMULATED_BALANCE: 'onHandSourcingOptions.SIMULATED_BALANCE',
  ANTICIPATED_BALANCE: 'onHandSourcingOptions.ANTICIPATED_BALANCE'
};

export const OnHandSourcingOptions = Object.keys(OnHandSourcings).map((key) => {
  return { key, label: OnHandSourcings[key as TOnHandSourcing] };
});

export const translatedOptions = (intl: IntlService) =>
  OnHandSourcingOptions.map((o) => ({ ...o, label: intl.t(o.label) }));

export const OnHandSourcingsArray: TOnHandSourcing[] = Object.keys(
  OnHandSourcings
) as TOnHandSourcing[];

export default OnHandSourcings;
